export const environment = {
  production: true,
  configJsonUrl: '',
  name: 'eca-security-ui',
  apiGatewayUrl: 'api-gateway.drcedirect.com',
  apiGatewayExceptions: {},
  deployment: 'production',
  deploymentExceptions: {},
  client: 'all',
  portalUrl: 'http://www.drcedirect.com/all/eca-portal-v2-ui',
  userManagementUrl: 'https://prod.uum.drcedirect.com',
  userManagementUiUrl: 'https://www.drcedirect.com/all/eca-user-management-ui',
  userManagementApplicationId: 15,
  apiGatewayConfig: {
    apiGatewayUrl: 'https://api-gateway.drcedirect.com/',
    apiGatewayCloudUrl: 'https://api-gateway-cloud.drcedirect.com',
    client: 'all',
    deployment: 'production',
    version: 'v0',
    enableCache: true
  },
  applicationId: 29,
  label: 'ECA Security Management'
};
